export default __webpack_public_path__ + "static/media/login-button.d30244c6.svg";